import React from 'react';
import {Dropdown} from 'semantic-ui-react';

import paths from '@paths';
import utils from '@utils';
import {Popup, PopupMessage} from '@components';

import {Props} from './types';

import './index.scss';

const AfterHeader: React.FC<Props> = props => {
  return (
    <div className="a__header-after">
      <div className="b__popup-faild">
        {props.me.isForceCanceled && (
          <Popup.Normal
            attention
            content={<PopupMessage.FaildCharging header />}
            position="bottom right"
            on="click"
            basic
          />
        )}
      </div>
      <Dropdown
        text={`${props.me.lastName} ${props.me.firstName}`}
        direction="left"
        className="b__user"
      >
        <Dropdown.Menu>
          <Dropdown.Item
            text="マイページ"
            onClick={() => {
              props.history.push(paths.myPage.main);
            }}
          />
          <Dropdown.Item
            text="プラン"
            onClick={() => {
              props.history.push(paths.price.main);
            }}
          />
          <Dropdown.Item
            text="ログアウト"
            onClick={async () => {
              await utils.amplify.signOut();
              window.location.href = '/';
            }}
          />
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default AfterHeader;
